var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import LayerPoisContent from './Layer-pois-content';
import Accordion from "react-bootstrap/Accordion";
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';

function CustomToggle(_ref) {
    var children = _ref.children,
        eventKey = _ref.eventKey;

    var decoratedOnClick = useAccordionToggle(eventKey, function () {});
    return React.createElement(
        'a',
        {
            type: 'button',
            onClick: decoratedOnClick
        },
        children
    );
}

var layerPoisGroups = function (_Component) {
    _inherits(layerPoisGroups, _Component);

    function layerPoisGroups() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, layerPoisGroups);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = layerPoisGroups.__proto__ || Object.getPrototypeOf(layerPoisGroups)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            groupOpen: ""
        }, _this.onClickGroups = function (id) {
            if (_this.state.groupOpen === id) {
                _this.setState({
                    groupOpen: ""
                });
            } else {
                _this.setState({
                    groupOpen: id
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(layerPoisGroups, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            // console.log("render - layerPoisGroups");
            return React.createElement(
                'div',
                null,
                React.createElement(
                    'div',
                    { className: 'sidebar-map-content-wrap', id: 'sidebar-map' },
                    React.createElement(
                        'div',
                        { className: 'sidebar-map-content desktop-view' },
                        React.createElement(
                            'div',
                            { className: 'panel-group', id: 'accordion1' },
                            React.createElement(
                                'div',
                                { className: 'panel panel-default group-content group1', style: { border: "1px solid #ddd", borderRadius: "5px", borderTop: "0" } },
                                React.createElement(
                                    Accordion,
                                    { activeKey: this.state.groupOpen === this.props.poi.idTipo ? this.props.poi.idTipo : "" },
                                    React.createElement(
                                        'label',
                                        { style: { position: "absolute", zIndex: 10000, left: "10px", top: "10px", bottom: 0, margin: "auto" }, 'class': 'containerCheck' },
                                        React.createElement('input', { type: 'checkbox', checked: this.props.poi.isChecked, onChange: function onChange() {
                                                return _this2.props.handleCheckboxPoisChange(_this2.props.poi.idTipo, true);
                                            } }),
                                        React.createElement('span', { 'class': 'checkmark' })
                                    ),
                                    React.createElement(
                                        CustomToggle,
                                        { eventKey: this.props.poi.idTipo },
                                        React.createElement(
                                            'div',
                                            { id: this.props.poi.idTipo, onClick: this.onClickGroups.bind(this, this.props.poi.idTipo), className: 'panel-heading map-content-level1' },
                                            React.createElement(
                                                'div',
                                                { className: 'panel-title' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'level1-heading' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'level1-heading-left' },
                                                        React.createElement('label', { className: 'check-container' }),
                                                        React.createElement(
                                                            'span',
                                                            { style: { marginLeft: 20 } },
                                                            this.props.poi.tipo
                                                        )
                                                    ),
                                                    React.createElement(
                                                        'div',
                                                        { className: 'level1-heading-right' },
                                                        React.createElement(
                                                            'span',
                                                            null,
                                                            '(',
                                                            this.props.poi.poisInfo.length,
                                                            ')'
                                                        ),
                                                        React.createElement(
                                                            'span',
                                                            null,
                                                            React.createElement('i', { className: 'fa fa fa-caret-down', 'aria-hidden': 'true' })
                                                        )
                                                    ),
                                                    React.createElement('div', { className: 'clearfix' })
                                                )
                                            ),
                                            React.createElement('div', { className: 'clearfix' })
                                        )
                                    ),
                                    this.state.groupOpen !== null && document.getElementById(this.props.poi.idTipo) !== null ? this.state.groupOpen === parseInt(document.getElementById(this.props.poi.idTipo).id) ? this.props.poi.poisInfo.map(function (item, i) {
                                        return React.createElement(
                                            Accordion.Collapse,
                                            { key: item.idTipo + i, eventKey: _this2.props.poi.idTipo },
                                            React.createElement(LayerPoisContent, { withOutGroupPoiOpen: _this2.props.withOutGroupPoiOpen, onClickWithOutGroups: _this2.props.onClickWithOutGroups, centerMapWihtOutFollow: _this2.props.centerMapWihtOutFollow, saveOldIOTImei: _this2.props.saveOldIOTImei, oldAssetsIOTImei: _this2.props.oldAssetsIOTImei, isOpenDeviceContent: _this2.props.isOpenDeviceContent, centerDevice: _this2.props.centerDevice, setLatLng: _this2.props.setLatLng, valueFilter: _this2.props.valueFilter, poiContent: item, filter: _this2.props.filter, id: item.assetsInfoId,
                                                centerMap: _this2.props.centerMap, handleCheckboxPoiChange: _this2.props.handleCheckboxPoiChange
                                            })
                                        );
                                    }) : null : null
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return layerPoisGroups;
}(Component);

export default layerPoisGroups;